import React, { Fragment, useState, useEffect } from "react";
import { Col, Card, CardHeader, CardBody, Form, FormGroup, Label, Row, Input } from "reactstrap";
import { Btn, H3, Breadcrumbs } from "../../../AbstractElements";
import { useForm, Controller } from "react-hook-form";
import { useLocation, useNavigate } from "react-router-dom";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { toast } from "react-toastify";
import Typeahead from "../../../CommonElements/TypeAhead";
import { Address, Customer, EditCustomer, Email, MobileNo, MobileNoError, Save, CustomerId, Name, Alternativephone } from "../../../Constant";
import { editCustomer, editCustomerRole, singleCustomer, singleCustomerRole } from "../../../CommonUrl";
import { useSelector } from "react-redux";
import { getClientUrlDataToken, postClientUrlWithToken } from "../../../Utils/restUtils";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import DatePicker from 'react-datepicker';
import moment from "moment";
import Transparentspinner from "../../Common/Loader/Transparentspinner";

const schema = yup.object().shape({
  address: yup.string().required().label('Address').max(60, 'Address must be at most 60 characters'),
  name: yup.string().required().label('Name'),
  email: yup.string().email('Inavlid email format').required().label('Email'),
  phonenumber: yup.string().required().label("Phone number"),
  altphonenumber: yup.string().required().label("Alternative Phone Number"),
});

const CustomerEdit = () => {
  const [loading, setLoading] = useState(false);
  const { register, handleSubmit, control, formState: { errors }, setValue } = useForm({
    resolver: yupResolver(schema)
  });
  const location = useLocation();
  const searchParams = location.search;
  const params = new URLSearchParams(searchParams);
  const param1 = params.get("id");
  const authState = useSelector((state) => state.auth);
  const navigate = useNavigate();

  useEffect(() => {
    getSingleCustomerData();
  }, []);

  const getSingleCustomerData = async () => {
    setLoading(true);
    let data = await getClientUrlDataToken(
      authState.apiUrl, authState.userRole === 1 ?
      singleCustomer + `?customer_id=${param1}` : singleCustomerRole + `?customer_id=${param1}`
    );
    if (data.status === true) {
      setValue("customerId", data.data.subscriber_id);
      setValue("name", data.data.first_name);
      setValue("email", data.data.email);
      setValue("phonenumber", data.data.country_code + data.data.mobile);
      setValue("countryCode", data.data.country_code);
      setValue("altphonenumber", data.data.country_code + data.data.alt_mobile);
      setValue("address", data.data?.address.replace(/"/g, "") || "");
      setLoading(false);
    } else if (data.status >= 400 && data.status <= 405) {
      navigate(`${process.env.PUBLIC_URL}/pages/error/error-page1`);
    } else if (data.status >= 500 && data.status <= 505) {
      navigate(`${process.env.PUBLIC_URL}/pages/error/error-page4`);
    } else {
      navigate(`${process.env.PUBLIC_URL}/pages/error/error-page3`);
    }
  };

  const onSubmit = async (data) => {
    const countryCode = data.countryCode;
    const phoneNumber = data.phonenumber;
    const altPhoneNumber = data.altphonenumber;
    if (phoneNumber.startsWith(countryCode)) {
      setLoading(true);
      const callNumber = phoneNumber.slice(countryCode.length);
      const altCallNumber = altPhoneNumber.slice(countryCode.length);
      const postRequest = {
        customer_id: param1,
        // subscriber_id: data.customerId,
        first_name: data.name,
        email: data.email,
        country_code: data.countryCode,
        mobile: callNumber,
        address: data.address,
        alt_mobile: altCallNumber
      };
      const editCustomerResponse = await postClientUrlWithToken(
        authState.apiUrl, authState.userRole === 1 ? editCustomer : editCustomerRole, postRequest
      );
      if (editCustomerResponse.status === 200) {
        if (editCustomerResponse.data.status === true) {
          navigate(`${process.env.PUBLIC_URL}/customers/customer`);
          toast.success(editCustomerResponse.data.message);
        } else {
          {editCustomerResponse.data.message.map((msg)=>{
            toast.error(msg);
            setLoading(false)
          })}
        }
      } else if (editCustomerResponse.status >= 400 && editCustomerResponse.status <= 405) {
        navigate(`${process.env.PUBLIC_URL}/pages/error/error-page1`);
      } else if (editCustomerResponse.status >= 500 && editCustomerResponse.status <= 505) {
        navigate(`${process.env.PUBLIC_URL}/pages/error/error-page4`);
      } else {
        navigate(`${process.env.PUBLIC_URL}/pages/error/error-page3`);
      }
    }
  };

  const handleBackButton=()=>{
    navigate('/customers/customer')
  }
  return (
    <Fragment>
      {loading && <Transparentspinner />}

      <Breadcrumbs mainTitle={Customer} parent="Customers" title={Customer} />
      <Card>
        <CardHeader className="pb-0">
          <H3>{EditCustomer}</H3>
        </CardHeader>
        <CardBody>
          <Form className="needs-validation" noValidate onSubmit={handleSubmit(onSubmit)}>
            <Row className="g-3 pt-3">
              {/* <Col md="6">
                <Label className="form-label" for="customerId">
                  {CustomerId} <span className="requireStar">*</span>
                </Label>
                <input
                  className="form-control"
                  id="customerId"
                  type="text"
                  disabled
                  {...register("customerId")}
                />
              </Col> */}
              <Col md="6">
                <Label className="form-label" for="name">
                  {Name} <span className="requireStar">*</span>
                </Label>
                <input
                  className="form-control"
                  id="name"
                  type="text"
                  {...register("name", { required: true })}
                />
                <p className="text-danger">{errors.name?.message}</p>
              </Col>
              <Col md="6">
                <Label className="form-label" for="email">
                  {Email} <span className="requireStar">*</span>
                </Label>
                <input
                  className="form-control"
                  id="email"
                  type="email"
                  {...register("email")}
                />
                <p className="text-danger">{errors.email?.message}</p>
              </Col>
            </Row>
            <Row className="g-3 pt-3">
              <Col md="6">
                <Label className="form-label" >
                  {MobileNo} <span className="requireStar">*</span>
                </Label>
                <Controller
                  name="phonenumber"
                  control={control}
                  defaultValue=""
                  render={({ field }) => (
                    <PhoneInput
                      {...field}
                      country={"bn"}
                      enableSearch={true}
                      onChange={(value, country) => {
                        setValue('countryCode', country.dialCode);
                        field.onChange(value);
                      }}
                      inputStyle={{
                        width: "100%",
                        height: "46px",
                        padding: "10px",
                        paddingLeft: "50px",
                        fontSize: "16px",
                        borderRadius: "8px",
                        borderColor: "rgba(83, 70, 134, 0.1019607843)",
                      }}
                      searchClass="none"
                    />
                  )}
                />
                <span className="text-danger">
                  {errors.mobile && MobileNoError}
                </span>
              </Col>
              <Col md="6">
                <Label className="form-label" >
                  {Alternativephone} 
                </Label>
                <Controller
                  name="altphonenumber"
                  control={control}
                  defaultValue=""
                  render={({ field }) => (
                    <PhoneInput
                      {...field}
                      country={"bn"}
                      enableSearch={true}
                      onChange={(value, country) => {
                        setValue('countryCode', country.dialCode);
                        field.onChange(value);
                      }}
                      inputStyle={{
                        width: "100%",
                        height: "46px",
                        padding: "10px",
                        paddingLeft: "50px",
                        fontSize: "16px",
                        borderRadius: "8px",
                        borderColor: "rgba(83, 70, 134, 0.1019607843)",
                      }}
                      searchClass="none"
                    />
                  )}
                />
                <span className="text-danger">
                  {errors.altphonenumber && MobileNoError}
                </span>
              </Col>
            </Row>
            <Row className="g-3 pt-3">
              <Col>
                <Label className="form-label" for="address">{Address} <span className="requireStar">*</span></Label>
                <textarea
                  id="address"
                  className="form-control"
                  {...register("address")}
                  maxLength={60}
                />
                <p className="text-danger">{errors.address?.message}</p>
                {errors.address?.type === 'maxLength' && <p>Address must not exceed 160 characters</p>}
              </Col>
            </Row>
            <div className="d-flex justify-content-center mt-3 gap-2">
              <Btn attrBtn={{ color: "primary" }} type="submit">
                {Save}
              </Btn>
              <button className="btn btn-light" onClick={()=>{handleBackButton()}} type="button">
                Cancel
              </button>
            </div>
          </Form>
        </CardBody>
      </Card>
    </Fragment>
  );
};
export default CustomerEdit;
